import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsItemForm from './SettingsItemForm'

class SetsActionItem extends SettingsItemForm {

  modelName = 'action'

  render() {
    const { atypes, data } = this.props;
    const { data: nData, errors } = this.state;

    var atypesOpt = [];
    for (var key in atypes){
      if(atypes.hasOwnProperty(key)) {
        atypesOpt.push({value:atypes[key].atype_id,label:atypes[key].atype_desc});
      }
    }
    atypesOpt.sort(sortOpts);

    const targetOpt = [
      {value: 0, label: 'modal'},
      {value: 1, label: 'link'},
      {value: 2, label: 'new tab'}
    ];

    if(this.state.editing){
      return(
        <tr>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.action_desc}
                name="action_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>
              {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            </div>
          </td>
          <td>
            <Select
              clearable={false}
              options={atypesOpt}
              value={nData.action_atype_id}
              onChange={e => this.updateSelect(e,'action_atype_id')}
              placeholder="Типы действия"
            />
          </td>
          <td>
            <Select
              clearable={false}
              options={targetOpt}
              value={nData.action_target}
              onChange={e => this.updateSelect(e,'action_target')}
              placeholder="Target"
            />
          </td>
          <td>
            <input
              type="checkbox"
              checked={nData.action_admin}
              name="action_admin"
              onChange={this.handleChBox}
            />
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.action_sort}
                name="action_sort"
                onChange={this.updateInput}
                placeholder="Сортировка"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.action_name}
                name="action_name"
                onChange={this.updateInput}
                placeholder="Action name"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.action_text}
                name="action_text"
                onChange={this.updateInput}
                placeholder="Action text"
              />
            </div>
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.action_desc}</td>
          <td>{atypes[data.action_atype_id].atype_desc}</td>
          <td>{targetOpt[data.action_target].label}</td>
          <td>{data.action_admin ? '\u2713' : ''}</td>
          <td>{data.action_sort}</td>
          <td>{data.action_name}</td>
          <td>{data.action_text}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsActionItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsActionItem.js